import { createSelector } from 'reselect';
import { getContentModel } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getEmailConfig = basicSelector(state => state.configModel);
export const emailConfigSelector = property => createSelector([getEmailConfig], config => config[property]);
export const contentModelFunctionSelector = func => {
  return createSelector([getContentModel], contentModel => func(contentModel));
};